export function getFilialData(positionData, filialId) {
    if (!filialId) return null;
    const { filialSettings } = positionData;
    if (!filialSettings) return null;
    const filialData = filialSettings.find((filial) => filial.filial_id === filialId);
    return filialData && filialData.setting;
}
